import { render, staticRenderFns } from "./OrganizationCollections.vue?vue&type=template&id=a00c82ca&"
import script from "./OrganizationCollections.vue?vue&type=script&lang=js&"
export * from "./OrganizationCollections.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationCollections.vue?vue&type=style&index=0&id=a00c82ca&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports